$(document).ready(initPage);

function initPage() {
  function checkScroll() {
    if ($(window).scrollTop() > 0) {
      $('body').addClass('is-scrolled');
    } else {
      $('body').removeClass('is-scrolled');
    }
  }
  checkScroll();
  $(window).scroll(function () {
    checkScroll();
  });

  $('.toggler').click(function () {
    $('body').toggleClass('is-menu');
  });

  const homeHeroSwiper = new Swiper('.swiper--home-hero', {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '.swiper--home-hero .swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl:
        '.swiper--home-hero .swiper-next, .swiper--home-hero .swiper-controls .control-next',
      prevEl:
        '.swiper--home-hero .swiper-prev, .swiper--home-hero .swiper-controls .control-prev',
    },
    observer: true,
    observeParents: true,
  });

  /*** Posts slider ***/

  // Desktop slider
  function setupPostSlider() {
    const isMobile = $(window).width() <= 1023;

    if (window._postSliderCleanup) {
      window._postSliderCleanup();
      window._postSliderCleanup = null;
    }

    if (!isMobile) {
      const postItems = document.querySelectorAll(
        '.section-hposts .hpost-item'
      );
      const postImages = document.querySelectorAll(
        '.section-hposts .hpost-img'
      );

      let currentIndex = 0;
      let intervalId = null;

      function setActive(index) {
        postItems.forEach((item, i) =>
          item.classList.toggle('is-active', i === index)
        );
        postImages.forEach((img, i) =>
          img.classList.toggle('is-active', i === index)
        );
        currentIndex = index;
      }

      function startAutoSwitch() {
        intervalId = setInterval(() => {
          let nextIndex = (currentIndex + 1) % postItems.length;
          setActive(nextIndex);
        }, 5000);
      }

      function stopAutoSwitch() {
        clearInterval(intervalId);
        intervalId = null;
      }

      setActive(currentIndex);
      startAutoSwitch();

      postItems.forEach((item, index) => {
        item.addEventListener('mouseenter', () => {
          stopAutoSwitch();
          setActive(index);
        });

        item.addEventListener('mouseleave', () => {
          startAutoSwitch();
        });
      });
    }
  }
  setupPostSlider();
  $(window).on('resize', function () {
    setupPostSlider();
  });

  /*** Mobile swiper ***/
  let postsSwiper = null;

  function initMobileSwiper() {
    const isMobile = $(window).width() <= 1023;

    if (!isMobile && postsSwiper) {
      postsSwiper.destroy(true, true);
      postsSwiper = null;
      $('.swiper-wrapper, .swiper-slide').children().unwrap();
      $('.swiper-container').remove();
      return;
    }

    if (postsSwiper || !isMobile) return;

    postsSwiper = new Swiper('.swiper--hposts-mobile', {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.hposts-i--mobile .swiper-pagination',
        clickable: true,
      },
    });
  }

  initMobileSwiper();

  $(window).on('resize', function () {
    initMobileSwiper();
  });

  /*******/

  $('.post-sidebar .card--gallery').on('click', function () {
    var $galleryLinks = $('.post-sidebar .gallery-list a');
    var items = $galleryLinks
      .map(function () {
        return {
          src: $(this).attr('href'),
          title: $(this).data('description') || '',
        };
      })
      .get();

    if (items.length > 0) {
      Spotlight.show(items);
    }
  });

  /*** Career ***/
  // const wrapper = document.querySelector('.swiper--gallery .swiper-wrapper');
  // const originalSlides = Array.from(wrapper.children);

  // originalSlides.forEach((slide) => {
  //   const clone = slide.cloneNode(true);
  //   clone.classList.add('slide-clone');
  //   wrapper.append(clone);
  // });

  const gallerySwiper = new Swiper('.swiper--gallery', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    loopedSlides: document.querySelectorAll('.swiper--gallery .swiper-slide')
      .length,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 500,
    pagination: {
      el: '.swiper--gallery .swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper--gallery .swiper-controls .control-next',
      prevEl: '.swiper--gallery .swiper-controls .control-prev',
    },
    observer: true,
    observeParents: true,
  });
}
